import { render, staticRenderFns } from "./LandingNavigation.vue?vue&type=template&id=b4ebb794"
import script from "./LandingNavigation.vue?vue&type=script&lang=js"
export * from "./LandingNavigation.vue?vue&type=script&lang=js"
import style0 from "./LandingNavigation.vue?vue&type=style&index=0&id=b4ebb794&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports